module.exports = __webpack_public_path__ + "img/chippa-united-fc.7e50e086.png";